export default class Accordion {
  constructor(element) {
    this.el = element;
    this.title = this.el.querySelector("[data-title]");
    this.svg = this.title.querySelector("svg");
    this.container = this.el.querySelector("[data-container]");
    this.content = this.el.querySelector("[data-content]");
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.init()
  }

  init() {
    this.el.addEventListener('click', e =>{
      this.toggleAccordion();
    })
  }

  toggleAccordion(){
    console.log("this.el: ", this.el)
    console.log('this.container: ', this.container)
    
    let contentHeight = this.content.offsetHeight;
    if (this.el.classList.contains("active")){
      this.svg.classList.remove("rotate")
      this.container.style.height = "0px";
      this.el.classList.remove("active");
      this.el.setAttribute('aria-expanded', false);
    }
    else{
      this.svg.classList.add("rotate")
      this.container.style.height = `${contentHeight}px`;
      this.el.classList.add("active");
      this.el.setAttribute('aria-expanded', true);
    }
  }

}
